import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfigApi } from 'src/app/config-api';
import { RefreshTimerService } from 'src/app/features/dashboard-main/services/refresh-timer.service';
import { Globals } from 'src/app/shared/global';
import { ApiCallingService } from 'src/app/shared/services/api-calling.service';
import moment from 'moment';
import { MsalService } from '@azure/msal-angular';
export const sharedBroadcast = new BroadcastChannel('');

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor(
    public router: Router,
    private toastr: ToastrService,
    private timer: RefreshTimerService,
    private apiCallingService: ApiCallingService,
    public globals: Globals,
    private authService: MsalService
  ) {
    sharedBroadcast.onmessage = (event) => {
      if (event.data === 'logout') {
        window.location.reload();
      }
    };
  }

  dateyear = '@' + moment().year();

  ngOnInit(): void {
    this.timer.startTimer(60 * 1000 * 60 * 24);

    this.timer.interval$.subscribe(() => {
      // this.logout();
    });
  }

  logout() {
    var url = ConfigApi.URLS.LOGOUT_URL;
    const payload = {
      userId: this.globals.getUser().UserId,
      description: 'logout due to 24 hours inactive',
    };
    this.apiCallingService
      .callAuthPostAPI(payload, 'POST', url)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(JSON.parse(res))) {
          var LoginWith = localStorage.getItem('LoginWith');
          localStorage.clear();
          // this.router.navigateByUrl("login");
          this.toastr.success(
            'You have been forcefully logged out. Please log in again.'
          );
          sharedBroadcast.postMessage('logout');

          // if (LoginWith == 'SSO') {
          //   this.authService.logoutRedirect({
          //     postLogoutRedirectUri: ConfigApi.HOST_BASE_URL
          //   });
          // } else {
          setTimeout(() => {
            window.location.reload();
          }, 500);
          // }
        }
      });
  }
}
